import { GoodsObjectService } from '@/services/GoodsObjectService';
import store from '@/store';
import _ from 'lodash';

export function sellingUnitQuantityToKg(goodsObject: any, sellingUnitQuantity: number, sellingUnit: string, totalQuantity?: number, order?: any) {
  const orderDetails = order || goodsObject.factoryTicket.order;
  let perKgRatio = goodsObject.perKgRatio;
  let quantityInKg = 0;
  const packingMode = goodsObject.packingMode.length > 0 ? goodsObject.packingMode : _.get(orderDetails,'product.packingMode',[]);
  const packingLevel: string = store.getters.getPackingLevelFromSellingUnit(sellingUnit, packingMode);
  if(perKgRatio[packingLevel]) {
    quantityInKg = sellingUnitQuantity / perKgRatio[packingLevel].value;
  }
  perKgRatio = GoodsObjectService.getFGPerKGRatios(goodsObject, orderDetails);
  quantityInKg = sellingUnitQuantity / perKgRatio[packingLevel].value;
  if(!totalQuantity) return quantityInKg;
  return quantityInKg > totalQuantity ? totalQuantity : quantityInKg;
}